/**
 * @fileoverview A legend entry in a Dashboard card's footer.
 * @description A gray label followed by a count coloured for its category (for example "Hot" in
 * gray, "4" in red), the pattern every Dashboard summary card's footer uses.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

interface DashboardLegendStatProps {
  label: string
  count: number
  toneClassName: string
  testId?: string | undefined
}

/**
 * @component
 * @param {DashboardLegendStatProps} props - The label, the count and its colour.
 * @param {string} props.label - The category's name.
 * @param {number} props.count - How many.
 * @param {string} props.toneClassName - The Tailwind text colour class for the count.
 * @param {string} [props.testId] - `data-testid` of the entry; its count adds `-count`.
 */
function DashboardLegendStat({ label, count, toneClassName, testId }: DashboardLegendStatProps) {
  return (
    <span className="text-xs font-medium text-slate" data-testid={testId}>
      {label}{' '}
      <strong
        className={`font-semibold ${toneClassName}`}
        data-testid={testId ? `${testId}-count` : undefined}
      >
        {count}
      </strong>
    </span>
  )
}

export default DashboardLegendStat
